<template>
  <div class="address_wrap">
    <div v-if="!info" class="c9 center">
      <span>您还未添加发票信息，</span>
      <a v-if="powerReg('dde7ff1a7df9b4be98b27cf395cc5989')" class="active_color" @click="add">点击添加</a>
    </div>
    <div v-if="info">
      <el-form ref="ruleForm" :model="info" :rules="rules" label-width="140px" class="mb35">
        <el-form-item label="发票抬头:" required>
          <el-input v-model="info.invoice_title" type="text" placeholder="请输入发票抬头" class="w100" clearable disabled />
        </el-form-item>
        <!-- <el-form-item label="税务登记号：" prop="invoice_code">
          <el-input v-model="info.invoice_code" type="text" placeholder="请输入税务登记号" class="w100" clearable :disabled="mode == 2" />
        </el-form-item> -->
        <el-form-item label="纳税人识别号:" prop="invoice_code">
          <el-input v-model="info.invoice_code" type="text" placeholder="请输入纳税人识别号" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <!-- <el-form-item label="开户行：" prop="bank">
          <el-input v-model="info.bank" type="text" placeholder="请输入开户行" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <el-form-item label="开户账号：" prop="bank_card">
          <el-input v-model="info.bank_card" type="text" placeholder="请输入开户账号" class="w100" clearable :disabled="mode == 2" @keyup.native="info.bank_card = info.bank_card.replace(/[^\d]/g, '')" />
        </el-form-item> -->
        <el-form-item label="开户行及账号:" prop="bank">
          <el-input v-model="info.bank" type="text" placeholder="请输入开户行及账号" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <el-form-item label="地址、电话:" prop="company_address">
          <el-input v-model="info.company_address" type="text" placeholder="请输入地址、电话" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <el-form-item label="开票内容:" prop="invoice_content">
          <el-input v-model="info.invoice_content" type="text" placeholder="请输入开票内容" class="w100" clearable :disabled="mode == 2" />
        </el-form-item>
        <!-- <el-form-item label="注册所在地址：" prop="company_address">
          <el-input v-model="info.company_address" type="text" placeholder="请输入注册所在地址" class="w100" clearable :disabled="mode == 2" />
        </el-form-item> -->
      </el-form>
      <div v-if="info" class="center">
        <el-button v-if="mode == 1" type="primary" @click="submitForm('ruleForm')">确定</el-button>
        <el-button v-if="mode == 1" @click="cancel">取消</el-button>
        <el-button v-if="mode == 2 && powerReg('945769fcb49fd3bd7bce004ba96a1464')" type="primary" @click="mode = 1">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getInvoiceInfo, addOrUpdateInvoiceInfo } from '@/api/invoice'
import { get } from '@/utils/storage'
export default {
  data() {
    return {
      info: null,
      rules: {
        invoice_code: [{ required: true, message: '请输入纳税人识别号', trigger: 'change' }],
        bank: [{ required: true, message: '请输入开户行及账号', trigger: 'change' }],
        // bank_card: [{ required: true, message: '请输入开户账号', trigger: 'change' }],
        // company_address: [{ required: true, message: '请输入注册所在地址', trigger: 'change' }]
        company_address: [{ required: true, message: '请输入地址、电话', trigger: 'change' }],
        invoice_content: [{ required: true, message: '请输入开票内容', trigger: 'change' }]
      },
      mode: 1
    }
  },
  methods: {
    async query() {
      const res = await getInvoiceInfo()
      if (res.code === 200) {
        this.info = res.data.length === 0 ? null : { ...this.info, ...res.data }
        this.mode = 2
      }
    },
    add() {
      this.mode = 1
      this.info = {
        invoice_title: JSON.parse(get('userinfo')).company_name,
        invoice_code: '',
        bank: '',
        bank_card: '',
        company_address: ''
      }
    },
    cancel() {
      this.query()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdateInvoiceInfo({ ...this.info }).then(res => {
            if (res.code === 200) {
              this.$message({ type: 'success', message: '保存成功' })
              this.query()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address_wrap{
  width: 600px;
  margin: 0 auto;
}
</style>
